import type { Message } from "@features/messaging/stores/messagingStore";
import { MessageBubble } from "@shared/components/MessageBubble";

export interface ChatBubbleProps {
  message: Message;
  isSent: boolean;
}

export function ChatBubble({ message, isSent }: ChatBubbleProps) {
  return <MessageBubble text={message.text ?? ""} variant={isSent ? "sent" : "received"} testId="chat-bubble" />;
}
